import React from 'react';
import styled from 'styled-components'
import FormatPrice from '../Helpers/FormatPrice';
import {NavLink} from "react-router-dom";
import { Button } from '../styles/Button';


const ListView = ({ products }) => {
    return (
        <Wrapper className="section">
            <div className='container grid'>
                {products.map((curElem) => {
                    const { SKU, subcategory, Item,main,name, Description, price,size: { length, width, height } = {}, } = curElem;
                    return (
                        <div className="card grid grid-two-column" >
                            <figure>
                                <img src={main} alt={SKU} />
                            </figure>
                            <div className="card-data">
                                <h3>{SKU} {name}</h3>
                                <p className="price"><FormatPrice price={price} /></p>
                                <p>{subcategory?.label} {Item}</p>
                                
                                <p>
                                    Description:<br/>
                                    Size :{length} x {width} x {height} mm<br /><br/>
                                </p>
                                <NavLink to={`/singleproduct/${SKU}`}>
                                    <Button className="btn">More Information</Button>
                                </NavLink>
                            </div>
                        </div>
                    )
                })}
            </div>

        </Wrapper>
    )
};
const Wrapper = styled.section`
padding: 3rem 0; 

.container {
  max-width: 120rem;
  overflow-y: auto;  
  max-height: 80vh;
  padding:1rem;
  }

  .grid {
    gap: 3.2rem;
    }

  figure {
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: all 0.5s linear;
  
  &::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.2s linear;
  cursor: pointer;
  }
   
  &:hover::after {
  width: 100%;
  }
   
  &:hover img {
  transform: scale(1.2);
  }
   
  img {
  max-width: 90%;
  margin-top: 1.5rem;
  height: 20rem;
  transition: all 0.2s linear;
  }
}

.card {
 border: 0.1rem solid rgb(170 170 170 / 40%);
 box-shadow: ${({ theme }) => theme.colors.shadowSupport};
 
.card-data {
padding: 0 2rem;
text-transform: capitalize;
}

.price {
  color: rgb(14, 96, 249);
  font-weight: 500;  
  font-size: 1.7 rem;
  }

h3 {
 margin: 2rem 0;
 font-weight: 300;
 font-size: 2.4rem;
 text-transform: capitalize;
 }

.btn {
  margin: 2rem 0;
  background-color: rgb(0 0 0 / 0%);
  border: 0.1rem solid rgb(98 84 243);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(98 84 243);

 &:hover {
  background-color: rgb(98 84 243);
  color:#fff;
  }

 &:hover a {
  color: #fff;
  }
  
 a {
   color: rgb(98 84 243);
  font-size: 1.4rem;
  }
}

.btn-main .btn:hover {
  color: #fff;
  }
 }
 
 
@media (max-width: ${({ theme }) => theme.media.mobile}) {
   padding: 2rem 0;

  .grid {
    gap: 1rem;
    }
  
  figure {
    img {
    max-width: 100%;
    margin-top: 2rem;
    height: auto;
    }
  }

  .card{
   padding: 0.5rem;

   h3{
    margin: 2rem 0;
    font-size: 1.8rem;
    }

   .btn{
    margin: 0.5rem 0;
    font-size: 1.5rem;
    } 
  }
`;

export default ListView
